import { DkimStatus } from "@redotech/redo-model/email/domain-verification";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const createCustomDomain = {
  name: "createCustomDomain" as const,
  input: z.object({ domain: z.string() }),
  output: z.object({ status: createEnum(DkimStatus) }),
};
